import React from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import {Link} from "react-router-dom";


export class BusinessEndCallToAction extends React.Component {

  getStartedClicked = () => {
    if (this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    const {classes} = this.props;

    return (
      <div className={classes.BusinessEndCallToAction}>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className={`${classes.sectionHeader} col-md-8 text-center`}>
              <h2>Sign up to get fully staffed.</h2>
              <p>Try SingleShift today and we'll waive the booking fee on your first shift.</p>
              <button type="button" onClick={this.getStartedClicked} className={`${classes.btn} btn btn-primary btn-xlg btn-pointer`}>Get Started</button>
              <p><Link to={config.routes.contact} className={classes.arrow}>Questions? Talk to our team</Link></p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = (theme) => ({
  BusinessEndCallToAction: {
    backgroundColor: '#ECEEF1',
    padding: '100px 0 125px',
  },
  btn: {
    margin: '4px 0 20px',
  },
});

export default withRouter(withStyles(styles)(BusinessEndCallToAction));



// WEBPACK FOOTER //
// ./src/parts/BusinessEndCallToAction.js